"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var createPallete_1 = require("./createPallete");

var createTheme_1 = require("./createTheme");

exports.lightTheme = createTheme_1.createTheme();
exports.darkTheme = createTheme_1.createTheme({
  pallete: {
    primaryScale: utils_1.invertColorScale(createPallete_1.defaultConfig.primaryScale),
    grayScale: utils_1.invertColorScale(createPallete_1.defaultConfig.grayScale),
    alertScale: utils_1.invertColorScale(createPallete_1.defaultConfig.alertScale),
    dangerScale: utils_1.invertColorScale(createPallete_1.defaultConfig.dangerScale),
    infoScale: utils_1.invertColorScale(createPallete_1.defaultConfig.infoScale),
    successScale: utils_1.invertColorScale(createPallete_1.defaultConfig.successScale),
    highlightScale: utils_1.invertColorScale(createPallete_1.defaultConfig.highlightScale)
  }
});